import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ShareAuthCheckData } from '../../types';
import type { DuplicateCreateApi } from '../duplicate-create-api';

@injectable()
export class DuplicateCreateApiImpl extends PsHttpService implements DuplicateCreateApi {
  get options() {
    return {
      baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
      headers: {
        'X-API-Version': '1.0',
      },
    };
  }

  createShareTask(inputData: ShareAuthCheckData) {
    return this.post<PatSnapCommonResponseData<string>>({
      url: '/secure-share/copy-task',
      data: inputData,
    }).then((res) => {
      return res.data as string;
    });
  }
}
